module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ArticleMenu":{"ariaLabel":"Kategorie článků","title":"Kategorie článků"}},"en":{"ArticleMenu":{"ariaLabel":"Article categories","title":"Article categories"}}}')
  delete Component.options._Ctor
}
